import { AuthorityType } from '@/types'

export interface DeleteAuthorityRequest {
  authorityType: AuthorityType
  authorityNos: string[]
}

export function DeleteAuthorityRequestToJSON(
  value: DeleteAuthorityRequest
): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    authority_nos:
      value.authorityNos.length > 0 ? value.authorityNos : undefined
  }
}
